import script from "./RecoverPasswordView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecoverPasswordView.vue?vue&type=script&setup=true&lang=ts"

import "./RecoverPasswordView.vue?vue&type=style&index=0&id=6bce3855&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bce3855"]])

export default __exports__